import { render, staticRenderFns } from "./RecurringBenefitRequestDetails.vue?vue&type=template&id=1bb9cc09&"
import script from "./RecurringBenefitRequestDetails.vue?vue&type=script&lang=js&"
export * from "./RecurringBenefitRequestDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports